<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout justify-center>
        <v-dialog v-model="show" persistent width="600px">
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Карточка</v-toolbar-title>
                        <v-tooltip left bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn
                                        fab
                                        dark
                                        small
                                        depressed
                                        color="blue lighten-2"
                                        @click="visAttachmentForm = true"
                                        v-on="on"
                                        class="mx-0 px-1"
                                >
                                    <v-icon>photo_library</v-icon>
                                </v-btn>
                            </template>
                            <span>Добавить/изменить прикрепления</span>
                        </v-tooltip>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="saveValue" :disabled="!valid">
                            <v-icon>save</v-icon>
                            {{cardModel.id === null ? ' Создать' : '\t\t Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list three-line subheader class="content">
                    <v-container>
                        <v-form
                            ref="form"
                            v-model="valid"
                        >
                            <v-row class="d-flex">
                                <v-col cols="6" class="py-0 pr-0">
                                    <v-text-field
                                            v-model="cardModel.title"
                                            :counter="35"
                                            label="Название карточки"
                                            class="ma-0 pa-0 pr-2 pt-3"
                                            required
                                            :rules="[rules.required, rules.maxLengthTitle]"
                                            dense
                                    />
                                </v-col>
                                <v-col cols="6" class="py-0 pl-0">
                                    <v-select
                                            v-model="cardModel.type"
                                            label="тип карточки"
                                            class="ma-0 ml-3 pa-0 pr-0 pt-3"
                                            :items="[{value: 1, text: 'Прочее со связью с профилем клиента'}, {value: 2, text: 'Прочее без связи с профилем клиента'}, {value: 3, text: 'Продукт'}, {value: 4, text: 'Заказ'}]"
                                            dense
                                    ></v-select>
                                </v-col>
                                <v-col cols="12">
                                    <client-card :user-id="cardModel.user_id" :dialog="show" v-show="cardModel.type !== 3"/>
                                </v-col>
                                <v-divider></v-divider>
                                <cards-in-card :cardId="editCardId" @addCards="addCards" @changeCountCards="changeCountCards"
                                               @removeCard="removeCard"
                                               @sumChange="sumChange"
                                />
                                <v-col cols="5" class="py-0">
                                    <v-text-field
                                            class="font-weight-black text-end"
                                            v-model="cardModel.price"
                                            dense
                                            hide-details
                                            solo
                                            prefix="Итого: "
                                            suffix="руб."
                                            type="number"
                                    />
                                </v-col>
                                <v-col cols="5" class="py-0">
                                    <v-btn @click="solveSum()" class="success" text
                                           v-show="cardModel.cards != null && cardModel.cards.length > 0"
                                    ><span class="text-capitalize">Посчитать по позициям</span></v-btn>
                                </v-col>
                                <v-col cols="12" md12 class="py-0 mt-4">
                                    <v-textarea
                                            auto-grow
                                            rows="1"
                                            name="input-7-1"
                                            v-model="cardModel.description"
                                            :counter="1500"
                                            label="Описание"
                                            class="ma-2 pa-2 my-0 py-0"
                                            required
                                            :rules="[rules.maxLengthText]"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                        <card-tag-box @cardTagsChange="cardTagsChange"/>
                        <media-library-box :attachments="attachments" v-show="attachments.length > 0"/>
                        <v-divider/>
                        <card-comment-form
                            :cardId="editCardId"
                        />
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                right
        >
            Успешно сохранено!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
        <media-library-select-box
                :visible="visAttachmentForm"
                :model="cardModel"
                @close="visAttachmentForm = false"
                :media-binds="mediaBinds"
                @updateAttachment="updateAttachment"
        ></media-library-select-box>
    </v-layout>
    
</template>

<script>
import { mapGetters } from 'vuex'
import CardCommentForm from './CardCommentForm'
import CardsInCard from './CardsInCard'
import ClientCard from './ClientCard'
import CardTagBox from './CardTagBox'
import MediaLibrarySelectBox from '../message/MediaLibrarySelectBox'
import MediaLibraryBox from "../message/MediaLibraryBox";

export default {
    name: 'CardForm',
    components: {
        CardCommentForm,
        CardsInCard,
        ClientCard,
        CardTagBox,
        MediaLibrarySelectBox,
        MediaLibraryBox
    },
    data() {
        return {
            show: false,
            snackbar: false,
            visKeyboardForm: false,
            visAttachmentForm: false,
            attachments: [],
            moduleBlock: false,
            modules: [],
            moduleGroups: [],
            cardModel: {
                id: null
            },
            rules: {
                required: value => !!value || 'Обязательное поле.',
                maxLengthTitle: value => (value.length <= 35) || 'Максимальная длина названия 28 символов.',
                maxLengthText: value => (value === null || value.length <= 1500) || 'Максимальная длина сообщения 3000 символов.'
            },
            valid: false,
            cardModelDef: {
                id: null,
                bot_id: null,
                card_list_id: null,
                updated_at: null,
                created_at: null,
                status: 1,
                user_id: null,
                type: 3,
                title: '',
                description: '',
                count: 0,
                tags: null,
                cards: [],
                price: 0
            },
            sum: 0,
            cardTags: [],
            mediaBinds: []
        }
    },
    props: ['editCardId', 'dialog', 'cardListId'],
    methods: {
        saveValue: function () {
            if (this.cardModel.card_list_id == null) {
                this.cardModel.card_list_id = this.cardListId
            }
            if (this.cardModel.price == null) {
                this.cardModel.price = 0
            }
            this.$store.dispatch('cards/cardCreate', this.cardModel).then(response => {
                if (this.cardModel.id == null) {
                    this.$emit('addCardToCardList', { cardModel: response.response.data, cardListId: this.cardListId })
                } else {
                    this.$emit('updateCard', { cardModel: response.response.data, cardListId: this.cardListId })
                }
                this.cardModel = response.response.data
                this.$store.dispatch('cards/createForCard', { tags: this.cardTags, card: this.cardModel }).then(response => {
                })
                this.$store.dispatch('messages/createMediaBindForModel', { files: this.attachments, model: this.cardModel, obj_type: 1 }).then(response => {
                    if (response.ok) {
                        this.mediaBinds = response.response.data
                    } else {
                        this.mediaBinds = []
                    }
                })
                this.snackbar = true
            })
        },
        loadModel(cardId) {
            if (cardId === null) {
                this.cardModel = Object.assign({}, this.cardModelDef)
                this.cardModel.card_list_id = this.cardListId
            } else {
                this.$store.dispatch('cards/cardTagsInCard', { cardId: cardId, botId: this.$route.params['pathMatch'] })
                this.cardModel = this._.cloneDeep(this.getCardById(cardId)) // JSON.parse(JSON.stringify(this.getCardById(cardId)))// this._.cloneDeep(this.getCardById(cardId))
                this.$store.dispatch('messages/fileBindAll', { obj_type: 1, model: this.cardModel }).then(response => {
                    if (response.ok) {
                        this.mediaBinds = response.response.data
                    }
                })
            }
            if (this.cardModel.user_id != null) {
                this.$store.dispatch('clients/clientsInCardList', this.cardModel.card_list_id)
            }
        },
        addCards(cards) {
            cards.forEach((item, cardIndex, array) => {
                let index = this.cardModel.cards.findIndex(card => card[0] === item[0])
                if (index === -1) {
                    this.cardModel.cards.push(item)
                } else {
                    this.cardModel.cards[index][1] += item[1]
                }
            })
            this.saveValue()
        },
        changeCountCards({ index, count }) {
            this.cardModel.cards[index][1] = count
            this.saveValue()
        },
        removeCard(index) {
            this.cardModel.cards.splice(index, 1)
            this.saveValue()
        },
        solveSum() {
            this.cardModel.price = this.sum
        },
        sumChange(value) {
            this.sum = value
        },
        cardTagsChange(value) {
            this.cardTags = value
        },
        updateAttachment({ selectedItems, saveModel }) {
            this.attachments = selectedItems
            if (saveModel) { this.saveValue() }
        }
    },
    computed: {
        ...mapGetters({
            cards: 'cards/cards',
            cardsLoaded: 'cards/getLoadedStatus',
            getCardById: 'cards/getCardById',
            cardTagsInCard: 'cards/cardTagsInCard'
        })
    },
    watch: {
        dialog() { this.dialog === true ? this.show = true : this.show = false },
        show() {
            if (this.show === false) {
                this.mediaBinds = []
                this.cardModel = Object.assign({}, this.cardModelDef)
                this.$refs.form.resetValidation()
                this.$emit('close')
            } else {
                this.loadModel(this.editCardId)
            }
        }
    },
    created() {
        this.cardModelDef.bot_id = +this.$route.params['pathMatch']
        this.$store.dispatch('cards/changeBotIdModelDefault', this.$route.params['pathMatch'])

        if (this.cardModel.user_id != null) {
            this.$store.dispatch('clients/clientsInCardList', this.cardModel.card_list_id)
        }

    }
}
</script>

<style scoped lang="scss">
    ::-webkit-scrollbar {
        width: $width-scroll-panel;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: $light;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: $blue-active;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: $blue-inactive;
    }

    .container {
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
</style>
